import { render, staticRenderFns } from "./protac.vue?vue&type=template&id=f935063e&scoped=true&"
import script from "./protac.vue?vue&type=script&lang=js&"
export * from "./protac.vue?vue&type=script&lang=js&"
import style0 from "./protac.vue?vue&type=style&index=0&id=f935063e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f935063e",
  null
  
)

export default component.exports